module.exports = __webpack_public_path__ + "img/icon-21.5c67742f.png";